import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import cls from 'classnames/bind';
import s from './Throbber.scss';

const cx = cls.bind(s);
class Throbber extends PureComponent {
  static propTypes = {
    isVisible: PropTypes.bool,
  };

  static defaultProps = {
    isVisible: false,
  };

  constructor(props, ctx) {
    super(props, ctx);
  }

  render() {
    const { isVisible, className, style } = this.props;

    return (
      <div
        className={cx('Throbber', className, {
          'Throbber--isVisible': isVisible,
        })}
        style={style /* твой последний шанс перебить стили */}
      />
    );
  }
}

export default Throbber;
